type NestedApiErrorPayload = {
  code?: string;
  message?: string;
  details?: string;
  requestId?: string;
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

export const extractAxiosApiError = (
  err: unknown,
  fallbackMessage = "Não foi possível processar sua mensagem agora.",
): { code: string; message: string } => {
  const data = (err as { response?: { data?: Record<string, unknown> } })
    ?.response?.data;

  if (!data) {
    return {
      code: "FORM_CHAT_ERROR",
      message: err instanceof Error ? err.message : fallbackMessage,
    };
  }

  const nestedError = data.error;
  if (isRecord(nestedError)) {
    const payload = nestedError as NestedApiErrorPayload;
    return {
      code:
        payload.code ||
        (typeof data.code === "string" ? data.code : "API_ERROR"),
      message:
        payload.message ||
        payload.details ||
        fallbackMessage,
    };
  }

  if (typeof nestedError === "string" && nestedError.trim()) {
    return {
      code: (typeof data.code === "string" && data.code) || "API_ERROR",
      message: nestedError,
    };
  }

  if (typeof data.message === "string" && data.message.trim()) {
    return {
      code: (typeof data.code === "string" && data.code) || "API_ERROR",
      message: data.message,
    };
  }

  return { code: "FORM_CHAT_ERROR", message: fallbackMessage };
};

export const toSafeInventoryQuantity = (value: unknown): number => {
  const parsed =
    typeof value === "number"
      ? value
      : Number(String(value ?? "").replace(",", "."));
  if (!Number.isFinite(parsed)) return 0;
  return Math.max(0, Math.round(parsed * 1000) / 1000);
};
